



































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";
import Decisions from "@/store/modules/Decisions";
import { VIEWPOINT_API } from "@/api/ViewpointApi";
import DecisionTable from "@/components/decisions/DecisionTable.vue";
import Apps from '@/store/modules/Apps';
import moment from 'moment';
import { type } from "os";
import { template } from "lodash";

const decisionsModule = getModule(Decisions);
const appsModule = getModule(Apps);


@Component({
    components: {
        DecisionTable
    }
})
export default class DecisionTableView extends Vue {
    
    @Prop({type: Array, default: () => []})
    decisions: any[];

    @Prop()
    title: string;

    @Prop()
    search: string;

    @Prop({ default: true, type: Boolean })
    singleList: boolean;
    
    
    private headers = [
        {text: 'Name', value: 'name'},
        // {text: 'Created', value: 'creationTimestamp'},
        {text: 'Last Edit', value: 'lastUpdatedTimestamp'},
        {text: 'Description', value: 'description'}
    ];

    private sourceNames = [];
    
    private folderDecisions = [];
    private listDecisions = [];

    private keys = [];
    private expandAll = false;

    private ownedDecisions = [];
    private sharedDecisions = [];

    private dataLoaded = false;

    get searchKey() {
        if (this.search == null) {
            return '';
        }
        return this.search
    }

    get idMap() {
        return this.decisions.reduce((acc, el, i) => {
            acc[el.decisionId] = i;
            return acc;
        }, {});
    }

    get decisionsList() {
        if (this.singleList) {
            return this.listDecisions;    
        }
        return this.folderDecisions;
    }

    get mergedDecisions() {
        if (this.searchKey != '' && this.searchKey != null) {
            return this.searchChildren([...this.decisionsList], this.singleList)
        } else {
            return this.decisionsList;
        }
    }

    private searchItem(decision) {
        const nameCheck = decision.name.toLowerCase().includes(this.searchKey.toLowerCase())
        if (this.singleList) {
            let templateCheck = false;
            if ( this.sourceNames[decision.decisionTemplateId] ) {
                templateCheck = this.sourceNames[decision.decisionTemplateId].toLowerCase().includes(this.searchKey.toLowerCase())
            }
            return nameCheck || templateCheck;
        }
        return nameCheck;
    }

    private searchChildren(decisions, list: boolean) {
        return decisions.filter((item) => {
            const keep = this.searchItem(item)
            if (!keep && !list) {
                if (item.children) {
                    const childNodes = this.searchChildren(item.children, list);
                    if (childNodes.length > 0) {
                        item.children = childNodes;
                        return true;
                    }
                }
            }
            return keep;
        })
    }

    private async getTemplateName( templateId: string ) {
        const parentDec = await VIEWPOINT_API.getDecision(templateId);
        console.log(parentDec)
        return parentDec ? parentDec.name : '';
    }

    @Watch('search')
    async onSearchChange(val) {
        if (val == null) {
            this.search = '';
        }
    }

    @Watch('decisions', {immediate: true, deep: true})
    async decisionsChanged(newDecisions) {
        this.listDecisions = [];
        this.dataLoaded = false;

        let decisionList = await Promise.all([...newDecisions].map(async (decision) => {
            let decisionSource = '';
            if (decision.decisionTemplateId) {
                if (newDecisions[this.idMap[decision.decisionTemplateId]]) {
                    decisionSource = newDecisions[this.idMap[decision.decisionTemplateId]].name;
                }
                else {
                    decisionSource = await this.getTemplateName( decision.decisionTemplateId );
                }
            }
            let decisionApps = await appsModule.checkAppsByDecision(decision.decisionId)
            return {
                    ...decision,
                    'apps': decisionApps.sort((a: any, b: any) => {
                        if (a.name === null || a.name === undefined) a.name = '';
                        if (b.name === null || b.name === undefined) b.name = '';
                        return a.name.localeCompare(b.name);
                    }),
                    'decisionTemplateName': decisionSource
            };
        }))

        this.listDecisions = decisionList
        this.dataLoaded = true;
    }
}
